import axios from 'axios';
import { API } from '../config';
import { jsonToFormData } from '../../presetation/utils/converJsonToFormData';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.put['Access-Control-Allow-Origin'] = '*';

const path = "/criancas";
const path2 = "/crianca";
const pathPost = "/cadastrar-crianca";

class CriancaService {

  novoCrianca(crianca) {
    return axios.post(API + path + pathPost, crianca);
  }

  getBlobAvatar(path, access_token, params) {
    return axios.get(path, {
      responseType: 'blob',
      params: params,
      headers: {
        Authorization: `Bearer ${access_token}`,
      },

    });
  }

  getIrmaosProcessoProcedimento(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/processo-procedimento/irmaos`)
  }

  getProcessoProcedimento(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/processo-procedimento`)
  }

  getValidSearchFiliacao(idFiliacao, nomeCrianca) {
    return axios.post(API + path + `/validar-duplicidade?idFiliacao=${idFiliacao}&nomeCrianca=${nomeCrianca}`)
  }

  putProcessoProcedimento(idCrianca, valuesToSend, idProcessoProcedimento) {
    return axios.put(API + path + `/${idCrianca}/processo-procedimento/${idProcessoProcedimento}`, jsonToFormData(valuesToSend, {}));
  }

  deleteProcessoProcedimento(idCrianca, idProcessoProcedimento) {
    return axios.delete(API + path + `/${idCrianca}/processo-procedimento/${idProcessoProcedimento}`);
  }

  deleteEntregaVoluntaria(idCrianca, idProcessoProcedimento) {
    return axios.delete(API + path + `/${idCrianca}/entrega-voluntaria/${idProcessoProcedimento}`);
  }

  getIrmaos(idCrianca) {
    return axios.get(API + path2 + `/${idCrianca}/irmaos`)
  }

  postIrmao(idCrianca, request) {
    return axios.post(API + path2 + `/${idCrianca}/irmaos`, request);
  }

  putEnderecoIrmao(idCrianca, idPessoaFisicaIrmao, request) {
    return axios.post(API + path2 + `/${idCrianca}/irmaos/${idPessoaFisicaIrmao}/atualizar-endereco`, request)
  }

  getFiliacao(idCrianca) {
    return axios.get(API + path2 + `/${idCrianca}/irmaos/filiacao`)
  }

  putIrmao(idCrianca, request, idPessoaFisicaIrmao) {
    return axios.put(API + path2 + `/${idCrianca}/irmaos/${idPessoaFisicaIrmao}`, request);
  }

  deleteIrmaos(idCrianca, idPessoaFisicaIrmao) {
    return axios.delete(API + path2 + `/${idCrianca}/irmaos/${idPessoaFisicaIrmao}`);
  }

  tipoSentenca() {
    return axios.get(API + "/tipos-sentencas")
  }

  getAnexo(id, opcao) {
    return axios.get(API + path + `/anexos/${id}/${opcao}`)
  }

  getListaAnexo(id) {
    return axios.get(API + `/anexo-crianca/listagem/${id}`)
  }

  getAnexoCrianca(id) {
    return axios.get(API + `/anexo-crianca/${id}`)
  }

  deleteAnexoCrianca(idAnexo) {
    return axios.delete(API + `/anexo-crianca/${idAnexo}`);
  }

  getPostAnexoCrianca(idCrianca, valuesToSend) {
    return axios.post(API + `/anexo-crianca/${idCrianca}`, jsonToFormData(valuesToSend, {}));
  }

  getPutAnexoCrianca(idAnexo, valuesToSend) {
    return axios.put(API + `/anexo-crianca/${idAnexo}`, jsonToFormData(valuesToSend, {}));
  }


  getListaAnexoCategorias() {
    return axios.get(API + `/anexo-crianca/categorias`)
  }

  getListaTipoAnexos() {
    return axios.get(API + `/anexo-crianca/tipos`)
  }

  getProfissionalizacao(idCrianca) {
    return axios.get(API + `/crianca/${idCrianca}/profissionalizacao`);
  }

  getPendencias(idCrianca) {
    return axios.get(API + `/criancas/${idCrianca}/pendencias/ativas`);
  }

  getDashboardCriancaPendencias(filters) {
    const {
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + path + "/pendencias/paginado", {
      params: {
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined
      }
    });
  }

  validCrianca(request) {
    return axios.post(API + "/criancas/validar", request);
  }

  deleteCrianca(idCrianca) {
    return axios.delete(API + `/criancas/${idCrianca}`);
  }

  postProfissionalizacao(idCrianca, profissionalizacaoRequest) {
    return axios.post(API + `/crianca/${idCrianca}/profissionalizacao`, jsonToFormData(profissionalizacaoRequest, {}));
  }

  putProfissionalizacao(idCrianca, profissionalizacaoRequest) {
    return axios.put(API + `/crianca/${idCrianca}/profissionalizacao`, jsonToFormData(profissionalizacaoRequest, {}));
  }

  postFotoCriancaPerfil(idCrianca, upload, dataFoto, idAnexoFoto) {
    var formData = new FormData();
    formData.append('upload', upload);
    formData.append('dataFoto', dataFoto);
    formData.append('idAnexoFoto', idAnexoFoto);



    return axios.post(API + `/anexos/anexo-crianca/${idCrianca}`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  }
  getCriancaTipoEscolaridade() {
    return axios.get(API + "/tipos-escolaridades");
  }

  getCriancaJustificativaEscolaridade() {
    return axios.get(API + "/tipos-justificativas-escolaridades");
  }

  getCriancaApadrinhamento(idCrianca) {
    return axios.get(API + `/crianca/${idCrianca}/programa-apadrinhamento`);
  }

  getValidarCriancaApadrinhamento(idCrianca) {
    return axios.get(API + `/crianca/${idCrianca}/programa-apadrinhamento/atualizar`);
  }

  getCriancaApadrinhamentoHistorico(idCrianca) {
    return axios.get(API + `/crianca/${idCrianca}/programa-apadrinhamento/historico`);
  }

  postCriancaApadrinhamento(idCrianca, apadrinhamentoRequestDTO) {
    return axios.post(API + `/crianca/${idCrianca}/programa-apadrinhamento`, apadrinhamentoRequestDTO);
  }

  putCriancaApadrinhamento(idApadrinhamento, idCrianca, apadrinhamentoRequestDTO) {
    return axios.put(API + `/crianca/${idCrianca}/programa-apadrinhamento/${idApadrinhamento}`, apadrinhamentoRequestDTO);
  }

  getCriancaSaude(idCrianca) {
    return axios.get(API + `/crianca/${idCrianca}/saude`);
  }

  postCriancaSaude(idCrianca, saudeRequestDTO) {
    return axios.post(API + `/crianca/${idCrianca}/saude`, saudeRequestDTO);
  }

  putCriancaSaude(idCrianca, saudeRequestDTO) {
    return axios.put(API + `/crianca/${idCrianca}/saude`, saudeRequestDTO);
  }

  getCriancaEducacao(idCrianca) {
    return axios.get(API + `/criancas/${idCrianca}/educacoes`);
  }

  postCriancaEducacao(idCrianca, educacaoRequest) {
    return axios.post(API + `/criancas/${idCrianca}/educacoes`, educacaoRequest);
  }

  putCriancaEducacao(idCrianca, educacaoRequest) {
    return axios.put(API + `/criancas/${idCrianca}/educacoes`, educacaoRequest);
  }

  listarCriancas() {
    return axios.get(API + path)
  }

  getCrianca(id) {
    return axios.get(API + path + "/" + id)
  }

  editarCrianca(id, dto) {
    return axios.put(API + path + `/${id}`, dto);
  }

  pesquisarCriancas(filters) {
    const {
      nome,
      nomeExato,
      nmFiliacao,
      munSeacId,
      idSeac,
      tipoMotivo,
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + path + "/find-simple", {
      params: {
        nome: nome !== "" ? nome : undefined,
        nomeExato: nomeExato ? nomeExato : undefined,
        nmFiliacao: nmFiliacao !== "" ? nmFiliacao : undefined,
        munSeacId: munSeacId !== "" ? munSeacId : undefined,
        idSeac: idSeac !== "" ? idSeac : undefined,
        tipoMotivo: tipoMotivo !== "" ? tipoMotivo : undefined,
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined
      }
    });
  }

  pesquisarCriancasDashboard(filters) {
    const {
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + path + "/find-dashboard", {
      params: {
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined
      }
    });
  }

  dadosImpressaoCrianca(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/imprimir`);
  }

  listarCriancaServicoAcolhimento(idServicoAcolhimento, exibirTodasCriancas) {
    return axios.get(API + path + `/servico-acolhimento/${idServicoAcolhimento}?exibirTodasCriancas=${exibirTodasCriancas}`);
  }

  listarPendentes(id) {
    return axios.get(API + path + `/${id}/registros`);
  }

  validaCPFCrianca(idCrianca, numeroDocumento, familiaAcolhedora) {
    return axios.get(API + path + `/${idCrianca}/validar-cpf-ficha?numeroDocumento=${numeroDocumento}${familiaAcolhedora === false ? "&validaFamiliaAcolhedora=" + familiaAcolhedora : ""} `);
  }

  inserirAnexo(anexo) {
    var formData = new FormData();

    for (let key in anexo) {
      formData.append(key, anexo[key]);
    }

    return axios.post(API + path + "/anexos", formData);
  }

  getDocumentacao(id) {
    return axios.get(API + path + "/documentacao/" + id)
  }

  getOcorrencias(idCrianca) {
    return axios.get(API + path2 + `/${idCrianca}/ocorrencia`)
  }

  getTipoOcorrencias() {
    return axios.get(API + `/tipos-ocorrencias`)
  }

  getOcorrenciasId(idCrianca, id) {
    return axios.get(API + path2 + `/${idCrianca}/ocorrencia/${id}`)
  }

  postOcorrencias(idCrianca, ocorrenciaRequestDTO) {
    return axios.post(API + path2 + `/${idCrianca}/ocorrencia`, ocorrenciaRequestDTO)
  }

  putOcorrencias(idCrianca, ocorrenciaRequestDTO, idOcorrencia) {
    return axios.put(API + path2 + `/${idCrianca}/ocorrencia/${idOcorrencia}`, ocorrenciaRequestDTO)
  }

  deleteOcorrencias(idCrianca, id) {
    return axios.post(API + path2 + `/${idCrianca}/ocorrencia/${id}/inativar`)
  }

  getReferencia(idCrianca) {
    return axios.get(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria`)
  }

  referenciaFamiliarComunitariaValidar(idCrianca, cpf) {
    return axios.post(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria/existe-relacionamento?cpf=${cpf}`)
  }
  getTipoReferencia() {
    return axios.get(API + "/tipos-referencias-familiares")
  }

  getTipoReferenciaPaeMae() {
    return axios.get(API + "/tipos-referencias-familiares/com-pai-mae")
  }

  getReferenciaId(idCrianca, idRelacionamento) {
    return axios.get(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria/${idRelacionamento}`)
  }

  postReferencia(idCrianca, referenciaFamiliarComunitariaRequest) {
    return axios.post(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria`, referenciaFamiliarComunitariaRequest)
  }

  putReferencia(idCrianca, referenciaFamiliarComunitariaRequest, idRelacionamento) {
    return axios.put(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria/${idRelacionamento}`, referenciaFamiliarComunitariaRequest)
  }

  deleteReferencia(idCrianca, idRelacionamento) {
    return axios.delete(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria/${idRelacionamento}`)
  }

  validarReferencia(idCrianca, pessoaFisicaReferenciasFamiliarRequest) {
    return axios.post(API + path2 + `/${idCrianca}/referencia-familiar-comunitaria/validar`, pessoaFisicaReferenciasFamiliarRequest)
  }


  getGuardaReferenciaFamiliar(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/guarda`);
  }

  postGuardaReferenciaFamiliar(idCrianca, guardaRequest) {
    return axios.post(API + path + `/${idCrianca}/guarda`, guardaRequest)
  }

  putGuardaReferenciaFamiliar(idCrianca, idGuarda, guardaRequest) {
    return axios.put(API + path + `/${idCrianca}/guarda/${idGuarda}`, guardaRequest)
  }

  postAnexoGuardaReferenciaFamiliar(idCrianca, anexo) {
    var formData = new FormData();
    formData.append('anexo', anexo);

    return axios.post(API + path + `/${idCrianca}/guarda/termo-guarda`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  }

  postCurriculoVitae(idCrianca, anexo, idProfissionalizacao) {
    var formData = new FormData();
    formData.append('anexo', anexo);
    formData.append('idProfissionalizacao', idProfissionalizacao);

    return axios.post(API + path2 + `/${idCrianca}/profissionalizacao/anexo-curriculo`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
  }

  getRelationamentosGuardaReferencia(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/guarda/relacionamentos-vinculos`)
  }

  getAnexoGuardaReferenciaFamiliar(idCrianca) {
    return axios.get(API + path + `/{idCrianca}/guarda/termo-guarda?idCrianca=${idCrianca}`)
  }

  getCurriculoVitaeDownload(idCrianca, idProfissionalizacao) {
    return axios.get(API + path2 + `/${idCrianca}/profissionalizacao/${idProfissionalizacao}/anexo-curriculo`)
  }

  getPendenciaDownload(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/pendencias/excel`, {
      responseType: "blob",
    });
  }

  getLaudoMedicoSaudeDownload(idCrianca, idSaudeDoenca) {
    return axios.get(API + path2 + `/${idCrianca}/saude/anexo-laudo-medico/${idSaudeDoenca}`)
  }

  deleteGuardaReferenciaFamiliar(idCrianca, idGuarda) {
    return axios.post(API + path + `/${idCrianca}/guarda/${idGuarda}/inativar`)
  }

  cadastrarProcessoProcedimento(idCrianca, valuesToSend) {
    return axios.post(API + path + `/${idCrianca}/processo-procedimento`, jsonToFormData(valuesToSend, {}));
  }

  getEntregaVoluntaria(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/entrega-voluntaria`);
  }

  cadastrarEntregaVoluntaria(idCrianca, valuesToSend) {
    return axios.post(API + path + `/${idCrianca}/entrega-voluntaria`, jsonToFormData(valuesToSend, {}));
  }

  editarEntregaVoluntaria(idCrianca, valuesToSend, idEntregaVoluntaria) {
    return axios.put(API + path + `/${idCrianca}/entrega-voluntaria/${idEntregaVoluntaria}`, jsonToFormData(valuesToSend, {}));
  }

  getAdocao(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/situacao-adocao`)
  }

  putSituacaoAdocao(idCrianca, valuesToSend) {
    return axios.post(API + path + `/${idCrianca}/situacao-adocao/observacao`, jsonToFormData(valuesToSend, {}));
  }

  getAtribuicaoCompetencia(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/atribuicao-competencia`)
  }

  getAtribuicaoCompetenciaValidar(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/atribuicao-competencia/validar`)
  }

  getAtribuicaoCompetenciaAtualizar(idCrianca) {
    return axios.get(API + path + `/${idCrianca}/atribuicao-competencia/atualizar`)
  }

  getAtribuicaoCompetenciaAtualizarPP(idCrianca, idProcessoProcedimento) {
    return axios.get(API + path + `/${idCrianca}/atribuicao-competencia/atualizar/${idProcessoProcedimento}`)
  }

  editarPromotoriaJuridica(idCrianca, valuesToSend) {
    return axios.post(API + path + `/${idCrianca}/atribuicao-competencia/promotoria`, jsonToFormData(valuesToSend, {}))
  }

  editarVaraInfancia(idCrianca, valuesToSend) {
    return axios.post(API + path + `/${idCrianca}/atribuicao-competencia/vara`, jsonToFormData(valuesToSend, {}))
  }

  reativarPromotoriaJuridica(idCrianca) {
    return axios.post(API + path + `/${idCrianca}/atribuicao-competencia/reativar-promotoria `)
  }

  reativarVaraInfancia(idCrianca) {
    return axios.post(API + path + `/${idCrianca}/atribuicao-competencia/reativar-vara`)
  }



}

const instanceCrianca = new CriancaService();
export default instanceCrianca;